import {
  Card,
  Checkbox,
  HStack,
  Text,
  View,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { startCase } from "lodash";
import { ScannerSettingsItem } from "../../../../../../../../utilities/barcode-scanner/types";
import { Spacings } from "react-native-ui-lib";

export interface ScannerSettingsItemRowProps {
  item: ScannerSettingsItem;
  label: string;
  handleChecked: () => void;
}

export function ScannerSettingsItemRow({
  item,
  label,
  handleChecked,
}: ScannerSettingsItemRowProps) {
  const { spacings } = useThemeProvider();

  return (
    <Card
      style={{
        display: "flex",
        flexDirection: "row",
        flexShrink: 0,
        flexGrow: 1,
        justifyContent: "space-between",
        marginLeft: Spacings.s5,
        marginRight: Spacings.s5,
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          flexGrow: 1,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Text variant="heading2">{startCase(label)}</Text>
        <View>
          <HStack spacing={spacings.s2}>
            <Checkbox value={item.enabled} onValueChange={handleChecked} />
            <View style={{ width: 24 }}></View>
          </HStack>
        </View>
      </View>
    </Card>
  );
}
